export default "__VITE_ASSET__70e16451__"